import React, { MouseEventHandler } from "react";
import Material from "../../model/Material";
import Alteration from "../../model/Alteration";

interface ISearchFilterCheckboxNumberProps {
  name: string;
  onChange: (
    inputID: string,
    newValue: string | boolean | Set<number> | Set<string>
  ) => void;
  data: Material[] | Alteration[];
  selected: Set<number>;
}

/* Process filters based on number values */
function SearchFilterCheckboxNumber({
  name,
  onChange,
  data,
  selected,
}: ISearchFilterCheckboxNumberProps) {
  const onFilterChange = (checked: boolean, id: number) => {
    if (checked) {
      selected.add(id);
    } else {
      selected.delete(id);
    }
    onChange(name, selected);
  };

  return (
    <div className="checkbox-filter">
      {data.map((item) => {
        return (
          <div key={name + "_" + item.id}>
            <input
              type="checkbox"
              id={name + "_" + item.id}
              name={name + "_" + item.id}
              checked={selected.has(item.id!)}
              onClick={(e) => onFilterChange(e.currentTarget.checked, item.id!)}
              onChange={() => {}}
            />
            <label>{item.name}</label>
          </div>
        );
      })}
    </div>
  );
}

export default SearchFilterCheckboxNumber;
